// import { useTypePosition } from '../context'
// import typePositionActions from './typePositionActions'

import { apiCall, ApiConfig } from '../../../config/api'
import { generateErrorFromResponse } from '../../../utils/errorHelper'
import { useTypePosition } from '../context'
import { TypePosition } from '../types/TypePosition'
import snackbarBusiness from './snackbarBusiness'
import typePositionActions from './typePositionActions'

/*
Copyright 2022-11-18 por alfonso moya Ecomsur Holding S.A ©
Detalle: Se agrega typePositionBusiness
*/
const typePositionBusiness = () => {
  const {
    setRows,
    setLoading,
    setTotalItems,
    changePage,
    changePageSize,
    setEditModalState,
    setSelectedTypePosition,
    setSearch
  } = typePositionActions()
  const {
    state: { pageSize, searchFields, page },
    dispatch
  } = useTypePosition()

  const { successMessage, showSnackbar } = snackbarBusiness()

  const fetchTypePositions = (page: number = 0, pageSize: number = 5) => {
    dispatch(setLoading(true))
    apiCall('GET', generateTypePositionUri(page, pageSize))
      .then((response) => {
        if (response.status !== 200) {
          throw new Error(`No fue posible obtener los registros.`)
        }
        return response.data
      })
      .then(({ items, totalItems }) => {
        dispatch(setRows(items))
        dispatch(setTotalItems(totalItems))
      })
      .catch(() => console.log('err'))
      .finally(() => dispatch(setLoading(false)))
  }

  const handleLoading = (isLoading: boolean) => dispatch(setLoading(isLoading))

  const generateTypePositionUri = (page: number, size: number): string => {
    const urlBase = `${ApiConfig.TypepositionApi}?pageIndex=${page}&pageSize=${size}`

    let params = ''

    if (searchFields.searchField !== '')
      params = `&${searchFields.searchField}=${searchFields.searchValue}`

    return urlBase + params
  }

  const handleChangePage = (_event: unknown, newPage: number) => {
    dispatch(changePage(newPage))
    fetchTypePositions(newPage, pageSize)
  }

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    fetchTypePositions(0, parseInt(event.target.value, 10))
    dispatch(changePageSize(parseInt(event.target.value, 10)))
    dispatch(changePage(0))
  }

  const openEditModal = (open: boolean, typePositionId: number) =>
    dispatch(setEditModalState({ open, typePositionId }))

  const closeEditModal = () => {
    dispatch(setSelectedTypePosition(undefined))
    dispatch(setEditModalState({ typePositionId: 0, open: false }))
  }

  const handleSelectedTypePosition = (typePosition: TypePosition | undefined) =>
    dispatch(setSelectedTypePosition(typePosition))

  const handleSearch = (event: any) => {
    dispatch(setSearch(event.target.name, event.target.value))
  }

  const handleResetSearch = () => {
    dispatch(setSearch('', ''))
  }

  const handleSaveTypePositionEdit = (modifiedTypePosition: TypePosition) => {
    apiCall(
      'PUT',
      `${ApiConfig.TypepositionApi}?typePositionId=${modifiedTypePosition.typePositionId}`,
      modifiedTypePosition
    )
      .then(successMessage)
      .then(() => fetchTypePositions(page, pageSize))
      .catch((errorResponse) => {
        const errorMessage = generateErrorFromResponse(errorResponse)
        showSnackbar(errorMessage, 'error')
      })
      .finally(closeEditModal)
  }

  return {
    fetchTypePositions,
    handleChangePage,
    handleChangeRowsPerPage,
    openEditModal,
    closeEditModal,
    handleLoading,
    handleSelectedTypePosition,
    handleSearch,
    handleResetSearch,
    handleSaveTypePositionEdit
  }
}

export default typePositionBusiness
